import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './CandidateApplied.module.scss';

const CandidateApplied: React.FC = () => {
  const ksquareGroup = '/assets/ksquare-group-head.png';
  const { t } = useTranslation();
  return (
    <div className={styles.candidateApplied}>
      <img
        className={styles.headerImg}
        src={ksquareGroup}
        alt="The Ksquare Group"
      />
      <div className={styles.candidateAppliedContainer}>
        <h1>{t('THANKS FOR APPLYING!')}</h1>
        <p>
          <span className={styles.bold}>
            {t('One of our recruiters will reach out to you shortly')}
            .
          </span>
        </p>
      </div>
    </div>
  );
};

export default CandidateApplied;
